/**
 * Single source of truth for the admin app version.
 * Convention: reusable-conventions.md §1.2 (mirrored from school-transport).
 *
 * Bump APP_VERSION in the SAME commit that adds the matching
 * `## [Admin X.Y.Z]` block to public/docs/CHANGELOG.md. Never let them drift.
 *
 * Read by: the sidebar "System live" chip + (future) post-login changelog modal.
 */
export const APP_NAME         = 'ZUR OPS';
export const APP_VERSION      = '1.927.0';
export const APP_VERSION_DATE = '2026-11-05';
